import {
    createWebHistory,
    createRouter,
    type RouteRecordRaw,
} from 'vue-router';
import HomePage from '@/pages/HomePage/HomePage.vue';

const routes: RouteRecordRaw[] = [
    {
        path: '/',
        name: 'Home',
        component: HomePage,
        meta: {
            keepAlive: true, // 启用缓存
        },
    },
    {
        path: '/result',
        name: 'Result',
        component: () => import('@/pages/ResultPage/ResultPage.vue'),
        meta: {
            keepAlive: false, // 不缓存结果页
        },
    },
    {
        path: '/error/:type',
        name: 'Error',
        component: () => import('@/pages/ErrorPage/ErrorPage.vue'),
        meta: {
            keepAlive: false, // 不缓存错误页
        },
    },
    {
        path: '/:pathMatch(.*)*',
        // redirect: { name: 'Error', params: { type: 'load-failed' } },
        redirect: { name: 'Home' }, // google 广告可能会在填充后改写 hash 参数, 所以不能重定向到错误页
    },
];

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes,
});

export default router;
